import { io } from "socket.io-client";

const SOCKET_URL = process.env.REACT_APP_AUTOMATION_URL;

// Create a single socket connection instance
const socket = io(SOCKET_URL, {
  autoConnect: false, 
  path: "/automation/socket.io"
});

socket.connect();

export default socket;
